import { render, staticRenderFns } from "./TemplatesTable.vue?vue&type=template&id=a896f86a&scoped=true"
import script from "./TemplatesTable.vue?vue&type=script&lang=js"
export * from "./TemplatesTable.vue?vue&type=script&lang=js"
import style0 from "./TemplatesTable.vue?vue&type=style&index=0&id=a896f86a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a896f86a",
  null
  
)

export default component.exports